import React, { useState } from "react";
import "./infoModal.css";
import { defaultIcons } from "./icons";

const InlineModal = ({ title, description, primaryAction, secondaryAction, icon, iconType, width }) => {
    const [loading, setLoading] = useState(false);

    const handlePrimaryClick = async () => {
        if (!primaryAction?.onClick) return;

        try {
            setLoading(true);
            await primaryAction.onClick();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="inline-modal-overlay">
            <div className="inline-modal-content" style={{ width: width || "" }}>
                <div className="d-flex flex-column gap-2">
                    <div className="align-self-center">
                        {icon || (iconType ? defaultIcons[iconType] : null)}
                    </div>
                    <span className="inline-modal-title">{title}</span>
                </div>
                {description && (
                    <div className="inline-modal-description">
                        {typeof description === "string"
                            ? description.split("\n").map((line, i) => (
                                <React.Fragment key={i}>
                                    {line}
                                    <br />
                                </React.Fragment>
                            ))
                            : description}
                    </div>
                )}
                <div className="inline-modal-actions gap-2">
                    {primaryAction && (
                        <button
                            className="inline-modal-button-primary"
                            onClick={handlePrimaryClick}
                            disabled={loading}
                        >
                            {loading ? (
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            ) : (
                                primaryAction.label
                            )}
                        </button>
                    )}
                    {secondaryAction && (
                        <button
                            className="inline-modal-button-secondary"
                            onClick={secondaryAction.onClick}
                            disabled={loading}
                        >
                            {secondaryAction.label}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default InlineModal;
